import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry, Sentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { initFeedbackWidget } from './lib/feedback';
import App from './App';
import './index.css';

initSentry();
initAnalytics();
initFeedbackWidget();

const Fallback = () => (
  <div className="flex min-h-screen items-center justify-center bg-blush px-6 text-center">
    <div>
      <h1 className="font-display text-2xl text-plum">Something went wrong.</h1>
      <p className="mt-2 font-body text-plum/70">
        Please refresh the page. Your details are safe and nothing was submitted.
      </p>
    </div>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
